import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';

export const Hero = ({ t, onOpenContact }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay - Changed to coastal cliff lighthouse */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1512649408904-c0a00fb810da"
          alt="Lighthouse"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#001f3f]/95 via-[#001f3f]/90 to-slate-900/85"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-[#D4AF37]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>

      {/* Content - Moved down */}
      <div className="relative z-10 container mx-auto px-4 text-center" style={{ marginTop: '150px' }}>
        <div className="max-w-4xl mx-auto">
          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            {t.hero.tagline}
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-slate-300 mb-10 leading-relaxed">
            {t.hero.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg"
              onClick={onOpenContact}
              className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#001f3f] hover:shadow-2xl hover:shadow-[#D4AF37]/50 transition-all duration-300 font-semibold px-8 py-6 text-lg hover:scale-105"
            >
              {t.hero.cta1}
            </Button>
            
            <Button 
              size="lg"
              variant="outline"
              onClick={onOpenContact}
              className="border-2 border-white/30 text-white hover:bg-white/10 backdrop-blur-sm px-8 py-6 text-lg hover:border-[#D4AF37] transition-all duration-300"
            >
              <Phone className="w-5 h-5 mr-2" />
              {t.hero.cta2}
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 flex flex-wrap justify-center gap-8 text-slate-300">
            <div className="text-center">
              <div className="text-3xl font-bold text-[#D4AF37]">5+</div>
              <div className="text-sm">
                {t.language === 'fr' ? 'Ans d\'Expérience' : 'Years Experience'}
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#D4AF37]">100+</div>
              <div className="text-sm">
                {t.language === 'fr' ? 'Clients Satisfaits' : 'Happy Clients'}
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#D4AF37]">50%</div>
              <div className="text-sm">
                {t.language === 'fr' ? 'Crédit d\'Impôt' : 'Tax Credit'}
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#D4AF37]">Brest</div>
              <div className="text-sm">Bretagne, France</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
